import { Alert, Box, Fade, Paper, SxProps, Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import type { ReactNode } from "react";
interface OnboardingFormWrapperProps {
  outerHeader?: ReactNode;
  outerFooter?: ReactNode;
  innerHeader?: ReactNode;
  innerFooter?: ReactNode;
  children: ReactNode;
  alignContentVertical?: "start" | "center" | "end";
  sx?: {
    container?: SxProps<Theme>;
    paper?: SystemStyleObject<Theme>;
  };
  error?: Error | null;
}

export const OnboardingFormWrapper = ({
  outerHeader,
  outerFooter,
  innerHeader,
  innerFooter,
  children,
  alignContentVertical = "start",
  sx = {
    container: {},
    paper: {},
  },
  error,
}: OnboardingFormWrapperProps) => {
  return (
    <Box
      sx={(theme) => ({
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: alignContentVertical,
        alignItems: "center",
        gap: { md: 3 },
        marginTop: { md: 3 },
        minHeight: 0,
        width: { xs: "100%", md: "clamp(30rem, 100%, 40rem)" },
        marginBottom: { xs: 0, md: theme.spacing(8) },
        ...((typeof sx?.container === "function"
          ? sx?.container(theme)
          : sx?.container) as SystemStyleObject<Theme>),
      })}
    >
      {outerHeader}
      <Paper
        elevation={1}
        sx={(theme) => ({
          width: "100%",
          flex: { xs: 1, md: "none" },
          display: "flex",
          flexDirection: "column",
          borderRadius: { xs: 0, md: theme.shape.borderRadius },
          border: { md: "0.0625rem solid" },
          borderColor: { md: "divider" },
          overflow: "hidden",
          gap: theme.spacing(4),
          minHeight: { xs: 0, md: theme.spacing(100) },
          ...sx?.paper,
        })}
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            flex: "none",
            gap: theme.spacing(2),
            bottomMargin: 4,
            paddingX: theme.spacing(6),
            paddingTop: innerHeader ? theme.spacing(6) : 0,
          })}
        >
          {innerHeader}
          {error && <Alert severity="error">{error.message ?? ""}</Alert>}
        </Box>
        <Fade in>
          <Box
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              flex: 1,
              overflow: "auto",
              bottomMargin: 4,
              paddingX: theme.spacing(6),
              paddingTop: !innerHeader ? theme.spacing(6) : 0,
              paddingBottom: !innerFooter ? theme.spacing(6) : 0,
            })}
          >
            {children}
          </Box>
        </Fade>
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            flex: "none",
            paddingBottom: innerFooter ? theme.spacing(6) : 0,
          })}
        >
          {innerFooter}
        </Box>
      </Paper>
      {outerFooter}
    </Box>
  );
};
